// Рантайм-конфиг приоритетнее build-time process.env.
//
// window._env_ заполняется docker-entrypoint.sh при старте контейнера
// из реальных переменных окружения контейнера — это позволяет использовать
// ОДИН собранный образ фронтенда на всех окружениях (dev/staging/prod),
// вместо пересборки под каждое (как было раньше через --build-arg).
//
// process.env.REACT_APP_* остаётся как fallback: в dev-режиме (npm start)
// window._env_ пуст (см. public/env.js — committed-заглушка), и конфиг
// берётся из client/.env через CRA как обычно.
const runtimeEnv = typeof window !== "undefined" ? window._env_ : undefined;

const getEnv = (key) => {
	const runtimeValue = runtimeEnv?.[key];
	if (runtimeValue !== undefined && runtimeValue !== "") {
		return runtimeValue;
	}
	return process.env[key];
};

export const SERVER_URL = getEnv("REACT_APP_SERVER_URL");
export const API = getEnv("REACT_APP_API");
export const AUTH_TOKEN = getEnv("REACT_APP_AUTH_TOKEN");
export const BEARER = getEnv("REACT_APP_BEARER");
export const CENTRIFUGE_URL = getEnv("REACT_APP_CENTRIFUGE_URL");
export const FUXA_URL = getEnv("REACT_APP_FUXA_URL");

const fuxaOrigin = (() => {
	try {
		return new URL(FUXA_URL).origin;
	} catch (e) {
		return null;
	}
})();

export const FUXA_VIEW_URL = fuxaOrigin ? `${fuxaOrigin}/view` : null;
